const baseUrl = 'https://dawa.aws.dk/';

export const adgangsAdresse = (query: string) => {
  return fetch(`${baseUrl}adgangsadresser?q=${query}`)
    .then(response => {
      return response.json();
    })
    .catch(error => {
      throw error;
    });
};

export const kommuner = () => {
  return fetch(`${baseUrl}kommuner`)
    .then(response => {
      return response.json();
    })
    .catch(error => {
      throw error;
    });
};
